import React from 'react'

const blogsAPI = [
    {
        id:1,
        title:"How Safe Is YouTube For Muslim Children?",
        paragraph:"Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread. Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread the knowledge of the Quran, especially among those where there are no reliable resources for learning the Quran.Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread.Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread the knowledge of the Quran, especially among those where there are no reliable resources for learning the Quran.Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread.Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread the knowledge of the Quran, especially among those where there are no reliable resources for learning the Quran.Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread.Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread the knowledge of the Quran, especially among those where there are no reliable resources for learning the Quran.",
        fb:"https://www.facebook.com",
        twitter:"https://www.twitter.com",
        linkedin:"https://www.linkedin.com",
        
        imgurl:"/assets/images/Homepage/blogs/bigblogimg.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/bigoneicons/teacher.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
    {
        id:2,
        title:"Blog Title 2",
        paragraph:"Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread. Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread the knowledge of the Quran, especially among those where there are no reliable resources for learning the Quran.Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread.Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread the knowledge of the Quran, especially among those where there are no reliable resources for learning the Quran.Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread.Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread the knowledge of the Quran, especially among those where there are no reliable resources for learning the Quran.Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread.Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread the knowledge of the Quran, especially among those where there are no reliable resources for learning the Quran.",
        imgurl:"/assets/images/Homepage/blogs/smcard/1.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/smcard/instructorsmpic.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
    {
        id:3,
        title:"Blog Title 3",
        paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris massa mauris. ",
        imgurl:"/assets/images/Homepage/blogs/smcard/2.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/bigoneicons/teacher.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
    {
        id:4,
        title:"Blog Title 4",
        paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris massa mauris. ",
        imgurl:"/assets/images/Homepage/blogs/smcard/3.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/smcard/instructorsmpic.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
    {
        id:5,
        title:"Blog Title 4",
        paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris massa mauris. ",
        imgurl:"/assets/images/Homepage/blogs/smcard/3.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/smcard/instructorsmpic.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
    {
        id:6,
        title:"Blog Title 2",
        paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris massa mauris. ",
        imgurl:"/assets/images/Homepage/blogs/smcard/1.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/smcard/instructorsmpic.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
    {
        id:7,
        title:"Blog Title 3",
        paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris massa mauris. ",
        imgurl:"/assets/images/Homepage/blogs/smcard/2.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/bigoneicons/teacher.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
    {
        id:8,
        title:"Blog Title 3",
        paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris massa mauris. ",
        imgurl:"/assets/images/Homepage/blogs/smcard/2.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/bigoneicons/teacher.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
    {
        id:9,
        title:"Blog Title 4",
        paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris massa mauris. ",
        imgurl:"/assets/images/Homepage/blogs/smcard/3.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/smcard/instructorsmpic.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
    {
        id:10,
        title:"Blog Title 2",
        paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris massa mauris. ",
        imgurl:"/assets/images/Homepage/blogs/smcard/1.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/smcard/instructorsmpic.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
    {
        id:11,
        title:"Blog Title 4",
        paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris massa mauris. ",
        imgurl:"/assets/images/Homepage/blogs/smcard/3.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/smcard/instructorsmpic.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
    {
        id:12,
        title:"Blog Title 2",
        paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris massa mauris. ",
        imgurl:"/assets/images/Homepage/blogs/smcard/1.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/smcard/instructorsmpic.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
    {
        id:13,
        title:"Blog Title 3",
        paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris massa mauris. ",
        imgurl:"/assets/images/Homepage/blogs/smcard/2.png",
        icon1:"/assets/images/Homepage/blogs/bigoneicons/1.png",
        courseType:"Islamic",
        icon2:"/assets/images/Homepage/blogs/bigoneicons/2.png",
        date:"17 Oct, 2023",
        teacherpic:"/assets/images/Homepage/blogs/bigoneicons/teacher.png",
        teachername:"Professor Mokhter Ahmad",
        designation:"Islamic Slolar"
    },
]


const BlogsCardAPI = () => {
  return (
    <>

    </>
  )
}

export {blogsAPI}

export default BlogsCardAPI